import { Button, Col, FormFeedback, FormGroup, Label } from "reactstrap";
import Input from "reactstrap/lib/Input";
import useForm from "src/hooks/useForm";
import * as yup from "yup";

const FormClaimDecarbonization = ({data, onClose, onSubmit: onHandleSubmit}) => {

    const validation = () => {
    
        return yup.object().shape({
          claim: yup.number().required("Claim is required!"),
        });
      };

      
  const {
    handleSubmit,
    errors,
    values,
    isSubmitting,
    isValid,
    handleChange,
  } = useForm({
    initialValues: {
      claim: "",
    },
    validation: validation(),
  });

  const onSubmit = (values,{setSubmitting}) => {
    setSubmitting(false)
    onHandleSubmit({...data, ...values})
  }

    return <>
    
          <form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup row>
              <Col md="3">
                <Label htmlFor="claim">Claim</Label>
              </Col>
              <Col xs="12" md="9">
                <Input
                  type="text"
                  name="claim"
                  id="claim"
                  placeholder="Claim"
                  autoComplete="off"
                  valid={!errors.claim}
                  invalid={!!errors.claim}
                  onChange={handleChange}
                  value={values.claim || ""}
                  disabled={isSubmitting}
                />
                <FormFeedback>{errors.claim}</FormFeedback>
              </Col>
            </FormGroup>
            <FormGroup>
              <Button
                type="submit"
                color="primary"
                className="mr-1"
                disabled={isSubmitting || !isValid}
              >
                {isSubmitting ? "Wait..." : "Save Changes"}
              </Button>
              <Button
                type="button"
                color="warning"
                className="mr-1"
                disabled={isSubmitting}
                onClick={() => onClose()}
              >
                Close
              </Button>
            </FormGroup>
          </form>
    </>
}

export default FormClaimDecarbonization;